import { getAPI, type FetchResponse, type UserAPI } from '@sydle/ui-api';
import { type BlogPost } from '../../types/blog';
import { blogCustomAPI } from './index';
import { getConfig } from '@sydle/ui-utils';
import { type UIAppConfig } from '@sydle/ui-app';

export interface GetPostInput {
  appIdentifier?: string;
  _id?: string;
  postIdentifier?: string;
  lang?: string;
  hash?: string;
}

export type GetPostOutput = { head: any; body: BlogPost };

export async function getPost(input: GetPostInput, forcePost: boolean): Promise<FetchResponse<GetPostOutput>> {
  const response = await blogCustomAPI.fetch<GetPostInput, GetPostOutput>(
    'getPost',
    {
      ...input,
      lang: getAPI<UserAPI>('userAPI')?.getCurrentLanguage() || 'en',
      hash: window?.['SYDLE']?.app?.hash || getConfig<UIAppConfig>('ui-app')?.applicationHash,
      appIdentifier: getConfig<UIAppConfig>('ui-app')?.APPLICATION_IDENTIFIER || '',
    },
    forcePost ? { forcePost: true } : undefined,
  );
  return response;
}
